import { modalsActionTypes } from "../actions/modals.actions";

export default function modalsReducer(state = null, action) {
  switch (action.type) {
    case modalsActionTypes.TOGGLE_MODAL:
      return {
        ...state,
        [action.key]: action.data,
      };
    default:
      return state;
  }
}
